/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesGameRoleSchema } from "./gameRoleSchema.ts";
import { goodLuckCoreEntitiesRegistrationStatusSchema } from "./registrationStatusSchema.ts";
import { goodLuckCoreEntitiesRiotAccountSchema } from "./riotAccountSchema.ts";
import { goodLuckCoreEntitiesRosterSchema } from "./rosterSchema.ts";
import { goodLuckCoreEntitiesTournamentRoleSchema } from "./tournamentRoleSchema.ts";
import { goodLuckCoreEntitiesTournamentSchema } from "./tournamentSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesTournamentRegistrationSchema = z.object({
  id: z.string().nullish(),
  tournamentId: z.string().nullish(),
  userId: z.string().nullish(),
  teamId: z.string().nullish(),
  rosterId: z.string().nullish(),
  tournamentTeamId: z.string().nullish(),
  riotAccountId: z.string().nullish(),
  get status() {
    return goodLuckCoreEntitiesRegistrationStatusSchema.optional();
  },
  get mainRole() {
    return goodLuckCoreEntitiesGameRoleSchema.optional();
  },
  get secondaryRole() {
    return goodLuckCoreEntitiesGameRoleSchema.optional();
  },
  get desiredRole() {
    return goodLuckCoreEntitiesTournamentRoleSchema.optional();
  },
  playerNote: z.string().max(200).nullish(),
  currentRank: z.string().nullish(),
  points: z.optional(z.int()),
  moderatorAdjustedPoints: z.int().nullish(),
  moderatorComment: z.string().nullish(),
  rejectedAt: z.iso.datetime().nullish(),
  rejectedByUserId: z.string().nullish(),
  rejectedReason: z.string().nullish(),
  cancelledAt: z.iso.datetime().nullish(),
  cancelledByUserId: z.string().nullish(),
  cancelledReason: z.string().nullish(),
  registeredAt: z.optional(z.iso.datetime()),
  isCheckedIn: z.optional(z.boolean()),
  checkedInAt: z.iso.datetime().nullish(),
  customFieldsAnswersJson: z.string().max(2000).nullish(),
  get tournament() {
    return goodLuckCoreEntitiesTournamentSchema.optional();
  },
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  get team() {
    return goodLuckCoreEntitiesRosterSchema.optional();
  },
  get riotAccount() {
    return goodLuckCoreEntitiesRiotAccountSchema.optional();
  },
});
